"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.primaryOrSecondary = void 0;
const primaryOrSecondary = (a, b) => (a && b ? `${a} (${b})` : a || b);
exports.primaryOrSecondary = primaryOrSecondary;
